import React from 'react';
import './StorySection.css';

const StorySection = React.forwardRef((props, ref) => {
  return (
    <div className="story-section" ref={ref}>
      <div className="story-content">
        <div className="story-image-container">
          <img src="/images/01_chris-at-door-greeting.png" alt="Chris at door greeting" className="story-image" />
        </div>
        <div className="story-text-container">
          <p>
            At Megavolt Electric, we know how important the safety of your home and business is to you. We want you to know that our team has the qualifications, experience and desire to guide you through your electrical project. Our locally owned and operated business respects and values our customers. We will diagnose your electrical issues, provide a transparent quote, and work around your schedule.
          </p>
        </div>
      </div>
    </div>
  );
});

export default StorySection;